export const oneTimeAnimate = (el, animationClassName) => {
  $(el)
    .removeClass(animationClassName)
    .addClass(animationClassName)
    .one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", () => {
      $(el).removeClass(animationClassName)
    })
}
